﻿/**
* DevExpress Dashboard (_textbox-item-properties-composer.js)
* Version:  20.1.8
* Build date: Oct 12, 2020
* Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var _text_box_item_1 = require("../../../model/items/metadata/_text-box-item");
var _form_adapter_editors_1 = require("../../form-adapter/_form-adapter-editors");
var _accordion_tab_1 = require("../../properties-controller/_accordion-tab");
var _base_properties_composer_1 = require("./_base-properties-composer");
var _shared_composers_1 = require("./_shared-composers");
var TextBoxItemPropertiesComposer = (function (_super) {
    __extends(TextBoxItemPropertiesComposer, _super);
    function TextBoxItemPropertiesComposer(customizeHandler) {
        return _super.call(this, customizeHandler) || this;
    }
    TextBoxItemPropertiesComposer.prototype._composeTabsCore = function (model) {
        var result = [
            new _accordion_tab_1.AccordionTab(_accordion_tab_1.KnownTabs.Common, 'DashboardWebStringId.AccordionTab.Common', _shared_composers_1.SharedComposers.getCommonWrapper(model, [__assign({}, _text_box_item_1.textBoxText, { formAdapterItem: _form_adapter_editors_1.filePickerEditor({ type: 'file', accept: '.rtf', readMode: 'text' }) })]))
        ];
        return result;
    };
    return TextBoxItemPropertiesComposer;
}(_base_properties_composer_1.DashboardItemPropertiesComposer));
exports.TextBoxItemPropertiesComposer = TextBoxItemPropertiesComposer;
